import {Navigate} from 'react-router-dom';
import React from 'react';

interface Props {
  isAllowed: boolean;
  children: React.ReactNode;
}

function ProtectedRoute({children, isAllowed}: Props) {
  if (!isAllowed) {
    return <Navigate to='/auth/login' />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
